export default __webpack_public_path__ + "static/media/ed-pastor-face.635464aa.jpg";